(function($) {
    $.widget('ca.caText', {
        options: {
            placeholder: '',
            placeholderClass: 'ca-text-field-placeholder',
            useEmptyPlaceHolder: false,
            width: ''
        },
        _create: function() {
            var element = this.element;
            var options = this.options;
            var firstParentContainer = $(element).parents('div').first();

            if (options.placeholder.length != 0 || options.useEmptyPlaceHolder) {
                if (element.val().length == 0) {
                    element.attr('placeholder', options.placeholder);
                    element.addClass(options.placeholderClass);
                }

                element[0].addEventListener('focus', function() {
                    if ($(this).val().length == 0) {
                        $(this).attr('placeholder', '');
                        $(this).removeClass(options.placeholderClass);
                    }
                });

                element[0].addEventListener('blur', function() {
                    if ($(this).val().length == 0) {
                        $(this).attr('placeholder', options.placeholder);
                        $(this).addClass(options.placeholderClass);
                    }
                });
            }

            if (firstParentContainer) {
                var clearInput = firstParentContainer.find('.clear-input');

                if (clearInput.length) {
                    clearInput.addEventListener('click', function(){
                        if (element.hasAttribute('selfpurifying')) {
                            element.value = '';
                            element.dispatchEvent(new Event('keyup'));
                            element.dispatchEvent(new Event('blur'));
                        }
                    });
                }
            }
            if (options.width) {
                element.width(options.width);
            }

            element[0].addEventListener('focus', function() {
                const parentElement = element[0].parentElement;
                const errorPopup = parentElement.querySelector('.ca-error-popup');
                if (errorPopup) {
                    errorPopup.style.zIndex = 2;
                }
            });

            element[0].addEventListener('blur', function() {
                const parentElement = element[0].parentElement;
                const errorPopup = parentElement.querySelector('.ca-error-popup');
                if (errorPopup) {
                    errorPopup.style.zIndex = 1;
                }
            });
        },

        setPlaceholder : function (placeholder) {
            var previousPlaceholder = this.options.placeholder;
            this.options.placeholder = placeholder;

            if (this.element.val().length == 0 || this.element.val() == previousPlaceholder) {
                this.element.val(this.options.placeholder);
                this.element.addClass(this.options.placeholderClass);
            }
        }
    });
})(jQuery);
